
<template>
  <div>
    <a class="ActTwelveFloat" :class="{ 'ON': isShow && uniq_id != 'P75968134'  }"
       :href="NEW_YEAR_ACT"
       target="_blank"
    >
<!--      <div class="time-box">-->
<!--        <span class="h">{{ times.h }}:</span>-->
<!--        <span class="m">{{ times.m }}:</span>-->
<!--        <span class="s">{{ times.s }}{{ times.hm }}</span>-->
<!--      </div>-->

      <i class="icon_close2" @click.stop.prevent="isShow = false"></i>

    </a>
  </div>
</template>

<script>
import {fnBasic} from "@/fn/_fn";
import {ACTIVE_GUOQING} from "@/constant/_constant/CON_BASIC";
import {fnLocalStorage} from "@/fn";
import {MODEL_GUO_QING_BUOY, MODEL_GUO_QING_FLOAT} from "@/constant/MODELS";
import mixinCountDown from "@/mixins/mixinCountDown";
import {ACT, NEW_YEAR_ACT, PAY_COMPANY_NEW} from "@/constant/_Public/Path";
import {mapState} from "vuex";

export default {
  name: "ActTwelveFloat",
  mixins: [mixinCountDown],
  computed: {
    ...mapState('user', [
      'phone', 'uniq_id', 'personVipState', 'personVipInfo', 'businessVipState', 'businessVipInfo', 'avatar', 'iphone', 'isLogin'
    ]),
  },
  data() {
    return {
      isShow: true,
      ACT,
      PAY_COMPANY_NEW,
      NEW_YEAR_ACT
    }
  },
  mounted() {
    // this.initTimer()
  },

  methods: {},
  beforeDestroy() {
    this.clearTimer();
  },
}
</script>

<style lang="scss" scoped>
@keyframes slide {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }

}

.ActTwelveFloat {
  display: block;
  transition: all 0.5s ease;
  @include BgImage2(140px, 165px, 'act/newYearFloat.png?v=1', 1);
  background-size: 140px 165px;
  //@include BgImage2(294px, 322px, 'act/act-float2.png?v=1', 1);
  //background-size: 294px 322px;
  vertical-align: middle;
  cursor: pointer;
  position: fixed;
  right: -999px;
  top: 150px;
  z-index: 88;
  animation: slide 2s ease-in-out infinite;

  &.ON {
    right: 15px;
  }


  .icon_close2 {
    @include BgImage(20px, 20px, 'pay/act-company/icon_close2.png');
    @include Position(1, 2, 50%, 160px);
    transform: translateX(50%);
    cursor: pointer;
    box-sizing: border-box;

    &:after{
      content: '';
      display: inline-block;
      width: 40px;
      height: 40px;
      //background: pink;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      //border: 1px solid #000;
    }
  }

  .time-box {
    height: 18px;
    box-sizing: border-box;
    position: absolute;
    left: 51%;
    bottom: 5px;
    transform: translateX(-50%);
    text-align: center;
    padding-left: 3px;
    white-space: nowrap;

    span {
      display: inline-block;
      width: 18px;
      height: 18px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 18px;
      font-size: 13px;
    }

    .h {
    }

    .m {
    }

    .s {
      width: 27px;
    }


  }

}
</style>

